import { render, staticRenderFns } from "./usageInfo.vue?vue&type=template&id=70a05718&"
import script from "./usageInfo.vue?vue&type=script&lang=ts&"
export * from "./usageInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports